var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14643 1.14643C1.43932 0.853533 1.91419 0.853533 2.20709 1.14643L10.7071 9.64645C11 9.93935 11 10.4142 10.7071 10.7071C10.4142 11 9.9393 11 9.6464 10.7071L1.14643 2.20709C0.853533 1.91419 0.853533 1.43932 1.14643 1.14643Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1768 0.426758C10.591 0.426758 10.9268 0.762538 10.9268 1.17676V10.1768C10.9268 10.591 10.591 10.9268 10.1768 10.9268H1.17676C0.762538 10.9268 0.426758 10.591 0.426758 10.1768C0.426758 9.7625 0.762538 9.4268 1.17676 9.4268H9.4268V1.17676C9.4268 0.762538 9.7625 0.426758 10.1768 0.426758Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavArrow);
export default __webpack_public_path__ + "static/media/nav-arrow.e3a1f9efd4d7d6713ed20a2d198f93df.svg";
export { ForwardRef as ReactComponent };